export const SET_AUTH_FORM = "SET_AUTH_FORM"
export const RESET_AUTH = "RESET_AUTH"
